// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';

// Selectors
import { isDraggingSelector } from '../../../reducers/draggingSelector';

// Actions
import { saveCurrentBoardToHome } from './saveToHomeActions';

// Components
import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';

// Constants
import { TIMES } from '../../../../common/utils/timeUtil';

// Styles
import './SaveToHomeButton.scss';

export const SAVE_TO_HOME_BUTTON_WIDTH = 128;

const MIN_TIMESTAMP = Date.now() + 2 * TIMES.SECOND;

const mapStateToProps = createStructuredSelector({
    isDragging: isDraggingSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSaveToHome: () => dispatch(saveCurrentBoardToHome()),
});

const SaveToHomeButton = ({ isDragging, dispatchSaveToHome }) => {
    const [ready, setReady] = React.useState(false);

    React.useEffect(() => {
        // Ensure that a minimum amount of time has passed before showing the save to board
        // otherwise a bit too much is going on on page load.
        const currentTimestamp = Date.now();
        const delay = MIN_TIMESTAMP > currentTimestamp ? MIN_TIMESTAMP - currentTimestamp : 100;

        setTimeout(() => {
            setReady(true);
        }, delay);
    }, []);

    return (
        <div className={classNames('SaveToHomeButton', { ready, dragging: isDragging })}>
            <div className="margin-spacer" />
            <Button onClick={dispatchSaveToHome}>
                <Icon name="save-workspace-arrow" />
                <span className="text">Save to Home</span>
            </Button>
        </div>
    );
};

SaveToHomeButton.propTypes = {
    isDragging: PropTypes.bool,
    dispatchSaveToHome: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveToHomeButton);
